// AUTO-GENERATED by buildSrc/src/main/kotlin/CoreTypesCodegen.kt
// DO NOT EDIT BY HAND. Regenerate via `./gradlew :frontend:generateCoreTypes`.
// Source of truth: core/src/commonMain/kotlin/be/aufildemescoutures/domain/live_tracking/core/

// ─── from be.aufildemescoutures.domain.live_tracking.core.comment ───────────────────────────────────────────────

export type ActionType = "BUY" | "REVIEW" | "QUESTION" | "NOTHING" | "CONTEST";
export const ActionType = {
  BUY: "BUY",
  REVIEW: "REVIEW",
  QUESTION: "QUESTION",
  NOTHING: "NOTHING",
  CONTEST: "CONTEST",
} as const;

export type CommentId = string;

export interface Comment {
  commentId: string;
  user: Customer;
  item: number;
  timestamp: string;
  fullComment: string;
  action: ActionType;
  sessionId: string | null;
}

// ─── from be.aufildemescoutures.domain.live_tracking.core.comment ───────────────────────────────────────────────

export interface NormalizedComment {
  source: string;
  liveVideoId: string;
  commentId: string;
  authorId: string | null;
  authorName: string | null;
  message: string;
  createdAt: string;
}

// ─── from be.aufildemescoutures.domain.live_tracking.core.live_event ───────────────────────────────────────────────

export interface LiveSessionStatus {
  sessionId: string | null;
  liveVideoId: string | null;
  liveId: string | null;
  state: string;
  error: string | null;
  retryAttempt: number;
  retryInMillis: number | null;
  receivedCount: number;
}

export interface LiveFeedMessage {
  kind: string;
  revision: number;
  status: LiveSessionStatus;
  comments: NormalizedComment[];
}

// ─── from be.aufildemescoutures.domain.live_tracking.core.comment ───────────────────────────────────────────────

export interface NoContest {
  type: "be.aufildemescoutures.domain.live_tracking.core.comment.ContestManagement.NoContest";
}

export interface Contest {
  type: "be.aufildemescoutures.domain.live_tracking.core.comment.ContestManagement.Contest";
  keyword: string;
}

export type ContestManagement = NoContest | Contest;

export const ContestManagementDisc = {
  NoContest: "be.aufildemescoutures.domain.live_tracking.core.comment.ContestManagement.NoContest",
  Contest: "be.aufildemescoutures.domain.live_tracking.core.comment.ContestManagement.Contest",
} as const;

export interface CommentForContest {
  comment: Comment;
  contest: Contest;
  score: number;
}

// ─── from be.aufildemescoutures.domain.live_tracking.core.customer ───────────────────────────────────────────────

export type CustomerId = string;

export interface NoRecordedUser {
  type: "be.aufildemescoutures.domain.live_tracking.core.customer.NoRecordedUser";
}

export interface FacebookUser {
  type: "be.aufildemescoutures.domain.live_tracking.core.customer.FacebookUser";
  name: string;
  id: string;
}

export type Customer = NoRecordedUser | FacebookUser;

export const CustomerDisc = {
  NoRecordedUser: "be.aufildemescoutures.domain.live_tracking.core.customer.NoRecordedUser",
  FacebookUser: "be.aufildemescoutures.domain.live_tracking.core.customer.FacebookUser",
} as const;

// ─── from be.aufildemescoutures.domain.live_tracking.core.live_event ───────────────────────────────────────────────

export type EventType = string;

export interface CommentPayload {
  type: "be.aufildemescoutures.domain.live_tracking.core.live_event.CommentPayload";
  comment: Comment;
}

export interface CommentForContestPayload {
  type: "be.aufildemescoutures.domain.live_tracking.core.live_event.CommentForContestPayload";
  commentForContest: CommentForContest;
}

export interface ContestPayload {
  type: "be.aufildemescoutures.domain.live_tracking.core.live_event.ContestPayload";
  contest: ContestManagement;
}

export type EventPayload = CommentPayload | CommentForContestPayload | ContestPayload;

export const EventPayloadDisc = {
  CommentPayload: "be.aufildemescoutures.domain.live_tracking.core.live_event.CommentPayload",
  CommentForContestPayload: "be.aufildemescoutures.domain.live_tracking.core.live_event.CommentForContestPayload",
  ContestPayload: "be.aufildemescoutures.domain.live_tracking.core.live_event.ContestPayload",
} as const;

export interface LiveEvent {
  payload: EventPayload;
  eventType: EventType;
}

export const LiveEventBus = {
  reviewBusName: "COMMENT.REVIEW",
  buyBusName: "COMMENT.BUY",
  newComment: "COMMENT.NEW",
  commentToValidate: "COMMENT.TO_VALIDATE",
  commentValidated: "COMMENT.VALIDATED",
  controlBus: "LIVE.CONTROL",
  contestSwitch: "CONTEST.SWITCH",
  contestComment: "CONTEST.COMMENT",
  stopEvent: "STOP",
} as const;

